export default {
  EVENTS: {
    HELP: {
      CONTACT: 'help.contact',
      FAQ_OPEN: 'help.faq_open'
    }
  },
  ENDPOINTS: {
    HELP: {
      CENTER: '/help',
      SUBMIT: '/help/contact'
    }
  }
};
